// Disable Loader overlay component to eliminate page blinking on navigation
const Loader = () => null;

export default Loader;
